import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HistorySection from "./components/HistorySection";
import ProductSection from "./components/ProductSection";
import ContactSection from "./components/ContactSection";

const App: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  const toggleMobileMenu = (): void => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="font-sans text-gray-800">
      <Header
        mobileMenuOpen={mobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
      />

      <HeroSection />
      <AboutSection />
      <HistorySection />
      <ProductSection />
      <ContactSection />

      <Footer />
    </div>
  );
};

export default App;
